import {
  AfterViewInit,
  Component,
  ElementRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { AgEditorComponent } from 'ag-grid-angular';
import { TcGridAutocompleteOption } from '../../interfaces/tc-grid.interface';
import { TcGridValidator } from '../../services/tc-grid-validator';
import { TcValidationsService } from '../../services/tc-validations.service';
@Component({
  selector: 'tc-grid-autocomplete-editor',
  templateUrl: './tc-grid-autocomplete-editor.component.html',
  styleUrls: ['./tc-grid-autocomplete-editor.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TcGridAutocompleteEditorComponent
  extends TcGridValidator
  implements AgEditorComponent, AfterViewInit
{
  @ViewChild('input') input: ElementRef;

  public value: any;
  public label: string;
  public filter: (query: string) => TcGridAutocompleteOption[];
  public options: TcGridAutocompleteOption[];

  constructor(public readonly tcValidationsService: TcValidationsService) {
    super(tcValidationsService);
  }

  ngAfterViewInit() {
    setTimeout(() => this.input?.nativeElement?.focus());
  }

  public agInit(params) {
    this.data = params?.data ?? null;
    this.value = params?.value ?? null;
    this.filter = params?.filter ?? null;
    this.label = params?.label ?? '';

    this.options = this.filter(this.value);
    this.validators = params?.validators;
  }

  public onSelection(updated) {
    this.value = updated;
    this.onChange(updated);
  }

  public onChange(updated) {
    this.options = this.filter(updated);
    super.validate(updated);
  }

  public getValue() {
    return this.value;
  }

  // all editions will be in popup
  // https://www.ag-grid.com/angular-grid/cell-editing/#popup
  isPopup() {
    return true;
  }
}
